const CANONICAL_PRODUCTION_ORIGIN = 'https://mumsconnect.nz';
const CANONICAL_PRODUCTION_HOSTS = new Set(['mumsconnect.nz', 'www.mumsconnect.nz']);
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1']);

export function getAuthRedirectOrigin() {
  const currentHost = window.location.hostname.toLowerCase();

  if (CANONICAL_PRODUCTION_HOSTS.has(currentHost)) {
    return CANONICAL_PRODUCTION_ORIGIN;
  }

  const configuredRedirect = (process.env.REACT_APP_OAUTH_REDIRECT_URL || '').trim();
  if (configuredRedirect && LOCAL_HOSTS.has(currentHost)) {
    return configuredRedirect;
  }

  return window.location.origin;
}
